export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13614.d15b39f0.jpg";